import { Directive } from "@angular/core";

/**
 * A generic wrapper for content in a mat-card with consistent padding and layout.
 *
 * @example
 * <mat-card>
 *   <mgd-card-content>...</mgd-card-content>
 * </mat-card>
 */
@Directive({
    selector: "mgd-card-content",
    host: {
        class: "mgd-card-content"
    }
})
export class CardContentDirective {}
